import { Box, ListItem, ListItemText, Stack } from "@mui/material";
import React from "react";

import { useUserProfile } from "api/services/useUserProfile";
import { DiscList } from "components/common/DiscList/DiscList";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useIsUserSciduck } from "hooks/useIsUserSciduck/useIsUserSciduck";
import { useUser } from "hooks/user/useUser";
import { GuidanceModal } from "new-components/modals/GuidanceModal";
import { Typography } from "new-components/typography/Typography";
import { setBlinkUsername } from "store/slices/Account/accountSlice";
import { selectDismissedOnboardings, setDismissedOnboardings } from "store/slices/Onboardings/onboardingsSlice";

import detectorDetailsUsageExampleSrc from "../assets/detector-details-usage-example.png";

export function DetectorDetailsOnboardingModal() {
  const user = useUser();
  const isUserSciDuck = useIsUserSciduck();
  const dispatch = useAppDispatch();
  const dismissedOnboardings = useAppSelector(selectDismissedOnboardings);
  const open =
    !isUserSciDuck &&
    !user.userprofile.detector_detail_onboarded &&
    !dismissedOnboardings.detectorDetail;
  const { updateUserProfile } = useUserProfile();

  const handleConfirmation = () => {
    updateUserProfile({
      detector_detail_onboarded: true,
    });
    dispatch(
      setDismissedOnboardings({
        detectorDetail: true,
      })
    );
  };

  const handleClose = () => {
    dispatch(setBlinkUsername(true));
    handleConfirmation();
  };

  return (
    <GuidanceModal
      title="Detector Details"
      subtitle="The detector details page is the dashboard for this detector."
      open={open}
      onClose={handleClose}
      onConfirmation={handleConfirmation}
      steps={[
        <Typography>
          Detector query and <span className="font-bold">most recent answered image</span>
        </Typography>,
        <Typography>
          Accuracy estimate, including <span className="font-bold">label image queries</span> button; a shortcut to help you
          provide ground truth answers
        </Typography>,
        <Typography>
          Table of queries and how they were answered
        </Typography>,
        <Stack>
          <Typography>Detector configuration for:</Typography>

          <DiscList
            sx={{
              "& .MuiListItemText-root": {
                margin: 0,
              },
            }}
          >
            <ListItem>
              <ListItemText
                primary={
                  <Typography>
                    <span className="font-bold">escalation</span> (includes confidence threshold)
                  </Typography>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary={
                  <Typography>
                    <span className="font-bold">setup</span> (includes detector notes)
                  </Typography>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary={
                  <Typography>
                    <span className="font-bold">code</span> (includes sample code to integrate into your application)
                  </Typography>
                }
              />
            </ListItem>
          </DiscList>
        </Stack>,
      ]}
      image={<Box component="img" src={detectorDetailsUsageExampleSrc} className="w-[372px]" />}
    />
  );
}
